import { render, staticRenderFns } from "./CreateJournal.vue?vue&type=template&id=03dfff9e"
import script from "./CreateJournal.vue?vue&type=script&lang=js"
export * from "./CreateJournal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03dfff9e')) {
      api.createRecord('03dfff9e', component.options)
    } else {
      api.reload('03dfff9e', component.options)
    }
    module.hot.accept("./CreateJournal.vue?vue&type=template&id=03dfff9e", function () {
      api.rerender('03dfff9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/jornalPayment/components/CreateJournal.vue"
export default component.exports